// Force every Bootstrap dropdown to open downward instead of letting Popper flip it upward
// (or place it unpredictably) when there is little room below. `data-display="static"` disables
// Popper positioning, so the menu uses default CSS placement directly under its toggle.
// Applied globally to all server-rendered dropdowns. Vue-rendered dropdowns (e.g. the filter
// dropdown) set the attribute in their own template since they mount after DOMContentLoaded.
// Limitation: dropdowns injected later (Cocoon, AJAX) are not covered — those must set
// data-display="static" themselves in their template or insertion handler.
const forceDropdownsDown = () => {
  document.querySelectorAll('[data-toggle="dropdown"]:not([data-display])').forEach((toggle) => {
    toggle.setAttribute('data-display', 'static')
  })
}

document.addEventListener('DOMContentLoaded', forceDropdownsDown)
